import { type FC, useContext } from "react";

import { FORMAT_TEXT_COMMAND } from "lexical";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

import { faBold } from "@fortawesome/free-solid-svg-icons/faBold";

import { EditorToolbarContext } from "./editor_toolbar_context";
import { IconButton } from "./icon_button";

export const EditorToolbarButtonBold: FC = () => {
  const [editor] = useLexicalComposerContext();
  const { isBold } = useContext(EditorToolbarContext);

  return (
    <IconButton
      icon={faBold}
      onClick={() => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold");
      }}
      aria-label="Bold"
      selected={isBold}
    />
  );
};
